<!--
  @author:tina
  @time:2022/4/1
  @disc:政策选择管理
 -->
<template>
  <div class="policy-content-manager" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar">
      <!-- <el-form-item label="级别" prop="status">
        <el-select v-model="form.status">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="政策名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入政策名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="add" v-permission="'0060602'">新增</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light"
      row-key="id">
      <el-table-column
        prop="name"
        label="政策名称"
        width="400">
      </el-table-column>
      <el-table-column
        prop="parentId"
        label="级别"
        width="">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.parentId==0">一级</el-tag>
          <el-tag v-else>二级</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatePerson"
        label="创建人"
        width="">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="创建时间"
        width="">
      </el-table-column>
      <el-table-column
        label="操作"
        width="200">
        <template slot-scope="scope">
          <el-button v-if="scope.row.parentId!=0" @click="edit(scope.row)" v-permission="'0060603'">编辑</el-button>
          <el-button v-if="scope.row.parentId!=0" type="danger" @click="handleDelete(scope.row)" v-permission="'0060604'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"></el-pagination>
    <add-or-edit-dialog :show.sync="editDialogShow" :info="editDialogInfo"></add-or-edit-dialog>
  </div>
</template>

<script>
import AddOrEditDialog from './addOrEditDialog'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'protocolPolicyContent',
  components: { AddOrEditDialog },
  data () {
    return {
      editDialogShow: false,
      editDialogInfo: '',
      statusArr: [
        { value: '', label: '全部' },
        { value: 1, label: '一级' },
        { value: 2, label: '二级' }
      ],
      form: {
        name: undefined
      }
    }
  },
  computed: {
    ...mapGetters({ list: 'getPolicyListNew', listState: 'getPolicyListNewState' })
  },
  methods: {
    ...mapActions(['queryPolicyListNew', 'deletePolicyInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.queryPolicyListNew(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.queryPolicyListNew({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.queryPolicyListNew({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 打开新增弹出层
    add () {
      this.editDialogShow = true
      this.editDialogInfo = {}
    },
    // 打开编辑弹出层
    edit (val) {
      this.editDialogShow = true
      this.editDialogInfo = val
    },
    // 删除
    handleDelete (row) {
      // 该一级分类下还有二级分类政策，是否全部删除?
      let tinfo = '确定删除该政策吗?'
      if (row.parentId === 0) {
        tinfo = '该一级政策下可能包含二级政策，是否全部删除?'
      }
      this.$confirm(tinfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletePolicyInfo({ id: row.id, parentId: row.parentId }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.queryPolicyListNew({ pageNo: 1 })
        })
      }).catch(() => {
        // 取消删除
      })
    },
    status (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
